import React from 'react'
import { Link } from 'react-router-dom'
import SEO from '../components/SEO'

export default function ForbiddenPage() {
  return (
    <>
      <SEO
        title="403 – Adgang begrænset"
        description="Du har ikke adgang til denne ressource hos Havdrup Rengøring."
      />

      <section className="py-20 sm:py-28 bg-gradient-to-b from-[#0d3836]/10 to-white text-center">
        <div className="mx-auto max-w-2xl px-4 sm:px-6">
          <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-2xl bg-amber-100 text-amber-700">
            <i className="fa-regular fa-lock-keyhole text-2xl" aria-hidden="true" />
          </div>

          <span className="text-sm font-semibold uppercase tracking-wider text-amber-700">
            Fejl 403
          </span>
          <h1 className="mt-2 text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900 font-display">
            Adgang ikke tilladt
          </h1>
          <p className="mt-4 text-base text-slate-600 leading-relaxed">
            Du har desværre ikke tilladelse til at se dette område. Hvis du mener, der er tale om en fejl, er du altid velkommen til at kontakte os.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-3 sm:gap-4">
            <Link
              to="/"
              className="inline-flex items-center gap-2 rounded-xl bg-[#0d3836] px-6 py-3 text-sm font-semibold text-white shadow-xs hover:bg-[#154e4a] transition-colors cursor-pointer w-full sm:w-auto justify-center"
            >
              <i className="fa-regular fa-house text-xs" aria-hidden="true" />
              <span>Gå til forsiden</span>
            </Link>
            <Link
              to="/kontakt"
              className="inline-flex items-center gap-2 rounded-xl border border-slate-300 bg-white px-6 py-3 text-sm font-semibold text-slate-800 hover:bg-slate-50 transition-colors cursor-pointer w-full sm:w-auto justify-center"
            >
              <span>Kontakt os</span>
            </Link>
          </div>
        </div>
      </section>
    </>
  )
}
